import { CHANGE_THEME } from './actions'

export default (previousState = 'light', { type, payload }) => {
  if (type === CHANGE_THEME) {
    return payload
  }
  const theme = localStorage.getItem('theme')
  return theme || previousState
}
